
import { Category } from '@/types';
import { processCategories } from './excel/rowProcessing';
import { toast } from 'sonner';

export const exportToCSV = async (categories: Category[], exportName: string) => {
  console.log('Starting CSV export with categories:', categories);
  
  if (!categories || categories.length === 0) {
    console.error('No categories to export');
    toast.error('No categories to export');
    return Promise.reject('No categories to export');
  }

  return new Promise<void>((resolve, reject) => {
    try {
      // Create a deep copy of categories to avoid any reference issues
      const categoriesCopy = JSON.parse(JSON.stringify(categories));
      console.log('Processing categories copy:', categoriesCopy);
      
      const rows = processCategories(categoriesCopy);
      console.log('Processed rows for export:', rows);

      if (rows.length === 0) {
        console.warn('No mapping rules found in categories, export will be empty');
        toast.warning('No mapping rules found in categories');
      }

      // Convert rows to CSV
      const headers = Object.keys(rows[0]).join(',');
      const csvRows = rows.map(row => 
        Object.values(row).map(value => 
          typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
        ).join(',')
      );
      
      const csvContent = [headers, ...csvRows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
      const now = new Date();
      const timestamp = now.toISOString().replace(/[:.]/g, '-');
      const fileName = `${exportName || 'BeeMap'} ${timestamp}.csv`;
      
      // Create download link and trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log('CSV export completed successfully');
      toast.success('CSV export completed successfully');
      resolve();
    } catch (error) {
      console.error('Error during CSV export:', error);
      toast.error('Error during CSV export');
      reject(error);
    }
  });
};

